<template>
    <div>
        <Header title="我的课程"/>
        <div
            class="scrollerView"
            :style="{ height: (wrapperHeight) + 'px' }"
        >
            <scroller
                :on-refresh="refresh"
                :on-infinite="infinite"
                :noDataText="dataSources.length > 1 ? Constants.ALL_LOAD_TIPS : ''"
                ref="infinite"
                class="scroller"
            >
                <courseItem v-for="(item, index) in dataSources" :key="index" :item="item" :type="3"/>
                <van-empty description="暂无信息～" v-if="dataSources.length < 1 && !loading" />
            </scroller>
        </div>
    </div>
</template>

<script>
import Lockr from 'lockr'
import Header from '@/components/Header'
import courseItem from '@/components/item/courseItem'
export default {
    /** 组件挂载 */
    components: {
        'Header': Header,
        'courseItem': courseItem,
    },
    /** 数据区 */
    data() {
        return {
            loading: false,
            wrapperHeight: 0, //屏幕高度 - 脚部
            // 列表
            page: 0,
            limit: 10,
            dataSources: [],
            no_more: false,
            no_data: false,
        };
    },
    /** 挂载后 */
    mounted() {
        this.wrapperHeight = document.documentElement.clientHeight;
    },
    /** 方法 */
    methods: {
        // 列表
        refresh() {
            this.page = 1;
            this.requestData();
            setTimeout(()=>{
                this.$refs.infinite.finishPullToRefresh();
            },500)
        },
        infinite() {
            this.page++
            this.requestData();
        },
        // 列表数据
        async requestData() {
            let url = this.API.my_enroll_subject_list;
            let params = {
                page: this.page,
                limit: this.limit
            };

            if (this.no_more) return this.$refs.infinite.finishInfinite(true);

            let result = await this.$post(url, params);
            if (result.code === this.GLOBAL.SUCCESS_CODE) {
                let list = result.data.data || []
                if (this.page === 1) {
                    this.dataSources = list
                } else {
                    this.dataSources = this.dataSources.concat(list)
                }
                this.$refs.infinite.finishInfinite(list.length < this.limit);
                this.no_more = list.length < this.limit;
                console.log('this.no_more---->', this.no_more);
            } else {
                this.Message({
                    title: result.msg,
                });
            }
        },
    },
    /** 销毁前 */
    beforeDestroy () {},
    /** 销毁后 */
    destroyed() {
    },
};
</script>

<style lang="less" scoped>
.scrollerView {
    position: relative;
    width: 100%;
}

.scroller {
    background: #F8F8F8;
}
</style>